// removed by extract-text-webpack-plugin
module.exports = {"Culture":"src-components-Destination-Culture----Culture-module---Culture---2Lp-5","Culture__Wrapper":"src-components-Destination-Culture----Culture-module---Culture__Wrapper---KMBlF","Culture__Item":"src-components-Destination-Culture----Culture-module---Culture__Item---3z77U"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Destination/Culture/Culture.module.scss
// module id = 725
// module chunks = 116453730430729